import { useState } from "react";
import AppDemo from "../app-demo/AppDemo";
import "./FolderContent.css";

// Possible: an app overview before demo
const FolderContent = ({ apps }) => {
  const [activeApp, setActiveApp] = useState(null);

  return !activeApp ? (
    <div className="app-grid">
      {apps.map(app => (
        <div
          key={app.name}
          className="app-tile"
          onClick={() => setActiveApp(app)}
        >
          <div>
            {app.logo ? (
              <img
                className={`app-logo ${app.fill_bg ? "fill" : ""} ${app.custom_border ? app.custom_border : ""}`}
                src={app.logo}
                alt={app.name}
                onClick={() => setActiveApp(app)} />
            ) : (
              "🎮"
            )}
          </div>

          <p>{app.name}</p>
        </div>
      ))}
    </div>
  ) : (
    <AppDemo app={activeApp} onBack={() => setActiveApp(null)} />
  );
};

export default FolderContent;